<template>
  <div v-if="httpstatus == 403" class="alert alert-danger text-center" role="alert">
    <h1>{{ $trans.get('__JSON__.No rights to view stamps') }}</h1>
  </div>
  <div v-for="(employee, index) in employees" class="row-container"
    :class="{ 'div-striped-bg': index % 2 == 0, 'div-bg': index % 2 == 1 }" :key="index">
    <div class="row employeetaskline grow ml-1 me-1">
      <div @click.stop="gotoEmployeeStamps(employee.id, 0)"
        class="col-3 border-table-top border-halis-lighter d-flex pt-1"
        role="button" style="align-items: center">
        <employee :employeelink="employeelink" :employee="employee" @toggle-external="toggleExternalStamps" />
      </div>
      <div @click.stop="gotoEmployeeStamps(employee.id, 0)" role="button"
        class="col-9 border-table-top border-halis-lighter">
        <span v-if="false && employee.difference_in < 0">{{ employee.difference_in }}m</span>
        <span v-if="false && employee.workhours > 0">{{ employee.workhours }}h</span>
        <div class="position-absolute h-100 bg-soft-primary elapsed" style="z-index: 10; left: 0px; top: 0; width: 10%">
        </div>

        <div v-if="employee.worktime?.flexible && !holiday && !employee.shift_start"
          @click.stop="gotoEmployeeStamps(employee.id, 0)"
          class="d-flex employeetask stamp rounded-right-pill rounded-left-pill" role="button" :style="{
            left: '0%',
            width: '100%',
            'background-image':
              'repeating-linear-gradient(-45deg, transparent, transparent 15px, rgba(255,255,255,.3) 15px, rgba(255,255,255,.3) 30px)',
            'background-color': 'green',
            opacity: 0.4,
          }">
          {{ $trans.get("__JSON__.Flexible workdays") }}
        </div>

        <div v-if="employee.shift_start && noAbsence(employee)" @click.stop="gotoEmployeeStamps(employee.id, 0)"
          class="d-flex employeetask stamp rounded-right-pill rounded-left-pill" role="button" :style="{
            left: employee.startpercent + '%',
            width: employee.endpercent + '%',
            'background-color': 'grey',
            opacity: 0.3,
          }">
          {{ $trans.get("__JSON__.planned") }} {{ employee.shift_start }} -
          {{ employee.shift_end }}
        </div>
        <div v-if="employee.absent" @click.stop="gotoEmployeeStamps(employee.id, 0)"
          class="d-flex employeetask stamp rounded-right-pill rounded-left-pill" role="button" :style="{
            left: '0%',
            width: '100%',
            'background-image':
              'repeating-linear-gradient(-45deg, transparent, transparent 15px, rgba(255,255,255,.3) 15px, rgba(255,255,255,.3) 30px)',
            'background-color':
              holiday != null
                ? 'green'
                : employee.absent == 'no_worktime'
                  ? 'red'
                  : 'grey',
            opacity: 0.4,
          }">
          {{ $trans.get("__JSON__." + employee.absent) }}
        </div>

        <div @click.stop="openContextMenu($event, employee, stamp)" v-for="(stamp, sindex) in employee.stamps"
          class="d-flex employeetask stamp"
          :class="[
            stamp.is_break ? 'p-0' : 'rounded-right-pill rounded-left-pill p-2',
            employee.externalstamps.length > 0 && can('external-stamps-list') ? 'border-glow' : ''
          ]"
          role="button" :style="{
            left: stamp.startpercent + '%',
            width: stamp.endpercent + '%',
            'background-image': stamp.preperation
              ? 'repeating-linear-gradient(-45deg, transparent, transparent 15px, rgba(255,255,255,.3) 15px, rgba(255,255,255,.3) 30px)'
              : 'none',

            'background-color': stamp.history_project
              ? stamp.history_project.color
              : 'lightgrey',
          }" v-tooltip :title="getTitle(stamp)" :data-id="stamp.id" :key="sindex">
          <span v-if="noAbsence(employee)" class="me-1">{{ stamp.client ? stamp.client.name : '' }} </span>{{
            stamp.history_project ? stamp.history_project.name : "-" }} {{ stamp.subproject?.name }}
        </div>

        <br />
      </div>
    </div>
    <div v-if="employee.externalstamps.length > 0 && showExternalStamps[employee.id] && can('external-stamps-list')"
      class="row employeetaskline grow ml-1 me-1">
      <div class="col-3 border-table-top border-halis-lighter d-flex pt-1"></div>
      <div class="col-9 border-table-top border-halis-lighter">
        <div v-for="(stamp, sindex) in employee.externalstamps"
          class="d-flex employeetask stamp"
          role="button" :style="{
            left: stamp.startpercent + '%',
            width: stamp.endpercent + '%',
            'background-color': stamp.project
              ? stamp.project.color
              : 'lightgrey',
          }" v-tooltip :title="getTitleExternal(stamp)" :data-id="stamp.id" :key="sindex">
          <span v-if="noAbsence(employee)" class="me-1">{{ stamp.client ? stamp.client.name : '' }}
          </span>
          {{ stamp.project ? stamp.project.name : "-" }}
        </div>
      </div>
    </div>

  </div>
  <!-- Modal -->
  <div class="modal fade" id="editModal" tabindex="-1" role="dialog" aria-labelledby="editModalLabel"
    aria-hidden="true"></div>


  <!-- contextmenu     -->
  <Teleport to="body">
    <div v-if="contextMenu.show">
      <div class="context-menu-backdrop" @click="closeContextMenu"></div>
      <div class="context-menu" id="context-menu" :style="{ top: contextMenu.y + 'px', left: contextMenu.x + 'px' }">
        <div class="context-menu-item"
          role="button" @click.stop="gotoEmployeeStamps(selectedStamp.employee_id, 0); closeContextMenu()">
          <span class="material-symbols-outlined"> overview </span> {{ $trans.get('__JSON__.Open stamps for employee')
          }}
        </div>
        <div class="context-menu-item"
          v-if="externalstampsCount > 0 && can('external-stamps-list')"
          role="button" @click.stop="openExternalStampsModal(); closeContextMenu()">
          <span class="material-symbols-outlined"> tooltip_2 </span> {{ $trans.get('__JSON__.Show external stamp info')
          }}
        </div>
      </div>
    </div>
  </Teleport>

  <!-- External Stamps Modal -->
  <Teleport to="body">
    <div class="modal" id="externalstampsModal">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ selectedEmployeeDetails ? selectedEmployeeDetails.lastname + ' ' +
              selectedEmployeeDetails.forename : '' }} - {{
                $trans.get('__JSON__.External Stamps Comparison') }} - {{ day }}</h5>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-4">
                <strong class="row">{{ $trans.get('__JSON__.Internal Stamps') }}</strong>
                <div class="row"> <strong class="col-3">{{ $trans.get('__JSON__.Workhours') }}:</strong>
                  <div class="col-9">{{ selectedEmployeeDetails?.employeedays[0].workhours ?? '' }}</div>
                </div>
                <div class="row"> <strong class="col-3">{{ $trans.get('__JSON__.Breakhours') }}:</strong>
                  <div class="col-9">{{ selectedEmployeeDetails?.employeedays[0].breakhours ?? '' }}</div>
                </div>
              </div>
              <div class="col-8">
                <strong>{{ $trans.get('__JSON__.External Stamps') }}</strong>
                <div class="row">
                  <div class="col">
                    <table class="table-hover">
                      <thead>
                        <tr>
                          <th>{{ $trans.get('__JSON__.Client') }}</th>
                          <th class="ml-2 pl-2">{{ $trans.get('__JSON__.Project') }}</th>
                          <th class="ml-2 pl-2">{{ $trans.get('__JSON__.Costcentre') }}</th>
                          <th class="ml-2 pl-2">{{ $trans.get('__JSON__.Duration') }}</th>
                          <th class="ml-2 pl-2">{{ $trans.get('__JSON__.Share on total internal worktime') }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in groupedDurationSeconds" :key="index">
                          <td>{{ item.clientName }}</td>
                          <td class="ml-2 pl-2">{{ item.projectName }}</td>
                          <td class="ml-2 pl-2">{{ item.costcentre }}</td>
                          <td class="ml-2 pl-2">{{ Number((item.duration_seconds / 60 / 60).toFixed(2)) }}</td>
                          <td class="ml-2 pl-2"> {{ Number(item.duration_seconds * 100 /
                            (selectedEmployeeDetails?.employeedays[0].workseconds +
                              selectedEmployeeDetails?.employeedays[0].breakseconds)).toFixed(2) }}% </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="row ml-1 me-1 mt-1">
              <div class="col-12 row p-0 m-0 overflow-hidden">
                <div v-for="hour in 24" class="col p-0 text-center d-inline-block border" :key="hour">
                  {{ hour - 1 }}
                </div>
              </div>
            </div>
            <div class="row employeetaskline grow ml-1 me-1">
              <div class="col-12">
                <div v-for="(stamp, sindex) in selectedEmployeeStamps"
                  class="d-flex employeetask stamp"
                  :class="[
                    stamp.is_break ? 'p-0' : 'rounded-right-pill rounded-left-pill p-2'
                  ]"
                  role="button" :style="{
                    left: stamp.startpercent + '%',
                    width: stamp.endpercent + '%',
                    'background-image': stamp.preperation
                      ? 'repeating-linear-gradient(-45deg, transparent, transparent 15px, rgba(255,255,255,.3) 15px, rgba(255,255,255,.3) 30px)'
                      : 'none',
                    'background-color': stamp.history_project
                      ? stamp.history_project.color
                      : 'lightgrey'
                  }" v-tooltip :title="getTitle(stamp)" :data-id="stamp.id" :key="sindex">
                  <span v-if="noAbsence(selectedEmployeeDetails)" class="me-1">{{ stamp.client ? stamp.client.name : ''
                  }} </span>
                  {{ stamp.history_project ? stamp.history_project.name : "-" }} {{ stamp.subproject?.name }}
                </div>
              </div>
            </div>
            <div class="row employeetaskline grow ml-1 me-1">
              <div class="col-12">
                <div v-for="(stamp, sindex) in selectedEmployeeExternalStamps"
                  class="d-flex employeetask stamp"
                  role="button" :style="{
                    left: stamp.startpercent + '%',
                    width: stamp.endpercent + '%',
                    'background-color': stamp.project
                      ? stamp.project.color
                      : 'lightgrey',
                  }" v-tooltip :title="getTitleExternal(stamp)" :data-id="stamp.id" :key="sindex">
                  <span v-if="noAbsence(selectedEmployeeDetails)" class="me-1">{{ stamp.client ? stamp.client.name : ''
                  }} </span>
                  {{ stamp.project ? stamp.project.name : "-" }}
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn-close" @click="closeExternalStampsModal"></button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>

</template>

<script>
import axios from "axios";
import { formatTime } from "../formatdate";

export default {
  name: "StampTable",
  emits: ["employeecount"],
  props: {
    status: String,
    day: String,
    location: Number,
    employee_location: Number,
    team: Number,
    employeelink: String,
    holiday: Object,
    client: Number,
    employer: Number,
  },
  computed: {
    externalEmployees() {
      return this.employees.filter((employee) => employee.employer?.shortname != "HAL");
    },
    groupedDurationSeconds() {
      const result = {};
      const stamps = this.selectedEmployeeDetails?.externalstamps || [];
      stamps.forEach(stamp => {
        const clientName = stamp.client?.name || '';
        const projectName = stamp.project?.name || '';
        const costcentre = stamp.project?.costcentre || '';
        const key = `${clientName}|${projectName}|${costcentre}`;
        if (!result[key]) {
          result[key] = {
            clientName,
            projectName,
            costcentre,
            duration_seconds: 0
          };
        }
        result[key].duration_seconds += stamp.duration_seconds || 0;
      });
      return Object.values(result);
    }
  },
  watch: {
    status(newValue, oldValue) {
      this.fetchAndPoll();
    },
    day(newValue, oldValue) {
      this.fetchAndPoll();
    },
    location(newValue, oldValue) {
      this.fetchAndPoll();
    },
    employee_location(newValue, oldValue) {
      this.fetchAndPoll();
    },
    team(newValue, oldValue) {
      this.fetchAndPoll();
    },
    client(newValue, oldValue) {
      this.fetchAndPoll();
    },
    employer(newValue, oldValue) {
      this.fetchAndPoll();
    },
  },
  data() {
    return {
      employees: [],
      actualStamp: {
        id: null,
        project_id: null,
        intime: null,
        outtime: null,
        employee_id: null,
      },
      error: "",
      polling: null,
      projects: null,
      httpstatus: 0,
      contextMenu: {
        show: false,
        x: 0,
        y: 0,
      },
      externalstampsCount: 0,
      selectedStamp: null,
      selectedEmployee: null,
      selectedEmployeeStamps: [],
      selectedEmployeeExternalStamps: [],
      selectedEmployeeDetails: null,
      showExternalStamps: {},
    };
  },
  created() {
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
  setup() { },
  mounted() {
    this.fetchProjects();
    this.fetchData();
    this.polling = setInterval(this.fetchData, 60000);
    document.addEventListener("click", this.closeContextMenu);
    document.addEventListener("scroll", this.closeContextMenu);
    document.addEventListener("keydown", this.handleKeydown);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.closeContextMenu);
    document.removeEventListener("scroll", this.closeContextMenu);
    document.removeEventListener("keydown", this.handleKeydown);
  },
  methods: {
    fetchAndPoll() {
      if (this.polling) {
        clearInterval(this.polling);
      }
      this.fetchData();
      this.polling = setInterval(this.fetchData, 60000);
    },
    fetchData() {
      axios
        .get("/api/stamps", {
          params: {
            status: this.status,
            day: this.day,
            location_id: this.location,
            employee_location_id: this.employee_location,
            team_id: this.team,
            client_id: this.client,
            employer_id: this.employer,
          },
        })
        .then((resp) => {
          this.employees = resp.data;
          // console.log(this.employees);
          // console.log(resp.data);
          this.$emit("employeecount", {
            employeeCount: this.employees.length,
            externalCount: this.externalEmployees.length,
          });
          $('.tooltip').hide();
        }).catch((error) => {
          console.log(error);
          this.httpstatus = error.response.status;
        });
    },
    stampClick(event) {
      this.loadStamp(event.target.getAttribute("data-id"));
    },
    loadStamp(stamp_id) {
      axios
        .get("/api/stamps/" + stamp_id)
        .then((resp) => {
          this.actualStamp = resp.data;
          this.actualStamp.intime = formatTime(this.actualStamp.intime);
          this.actualStamp.outtime = formatTime(this.actualStamp.outtime);
          $("#editModal").modal("show");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveStamp() {
      if (this.actualStamp.id) {
        axios
          .put("/api/stamps/" + this.actualStamp.id, this.actualStamp)
          .then((resp) => {
            // console.log(resp.data);
            this.employees.forEach((employee, eindex) => {
              employee.stamps.forEach((stamp, sindex) => {
                if (stamp.id === this.actualStamp.id) {
                  this.employees[eindex].stamps[sindex] = this.actualStamp;
                }
              });
            });
            this.fetchData();
            $("#editModal").modal("hide");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    objectToArray() {
      var data = [];
      for (const [key, value] of Object.entries(this.actualStamp)) {
        data[key] = value;
      }
      return data;
    },
    fetchProjects() {
      axios
        .get("/api/projects/all", {})
        .then((resp) => {
          this.projects = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getTitle(stamp) {
      var title = "";
      if (stamp.client) {
        title = stamp.client.name + " ";
      }

      title += stamp.history_project?.name + " ";

      //console.log(stamp);
      if (stamp.subproject) {
        title += stamp.subproject.name + " ";
      }

      title += formatTime(stamp.intime).replace("T", " ") + " - ";

      if (stamp.outtime) {
        title += formatTime(stamp.outtime).replace("T", " ");
      } else {
        title += "open";
      }

      if (stamp.preperation) {
        title += ' ' + this.$trans.get('__JSON__.preperation');
      }
      return title;
    },
    getTitleExternal(stamp) {
      var title = "";
      if (stamp.client) {
        title = stamp.client.name + " ";
      }

      if (stamp.project_id == 0) {
        title += this.$trans.get('__JSON__.No project(0) mapping found') + " ";
      } else {
        title += stamp.project?.name + " ";
      }

      //console.log(stamp);
      if (stamp.subproject) {
        title += stamp.subproject.name + " ";
      }

      title += formatTime(stamp.start_at).replace("T", " ") + " - ";

      if (stamp.end_at) {
        title += formatTime(stamp.end_at).replace("T", " ");
      } else {
        title += "open";
      }

      if (stamp.preperation) {
        title += ' ' + this.$trans.get('__JSON__.preperation');
      }
      return title;
    },
    gotoEmployeeStamps(employee_id, absence_id) {
      if (absence_id > 0) {
        window.location = "/absences?employee_id=" + employee_id;
      } else {
        window.location = "/employees/" + employee_id + "/stamps?day=" + this.day;
      }
      return false;
    },
    noAbsence(employee) {
      const stamps = employee.stamps.filter((stamp) => stamp.absence == true);
      if (stamps.length == 0) {
        return true;
      }
      return false;
    },
    openContextMenu(event, employee, stamp) {
      this.hideTooltip();
      // console.log(employee);
      // console.log(stamp);
      this.selectedStamp = stamp;
      this.externalstampsCount = employee.externalstamps.length;
      this.selectedEmployee = employee;
      this.contextMenu.show = true;

      this.$nextTick(() => {
        const menuWidth = $('#context-menu').outerWidth();
        const menuHeight = $('#context-menu').outerHeight();
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        const mouseX = event.clientX;
        const mouseY = event.clientY;

        if (mouseX + menuWidth > viewportWidth) {
          this.contextMenu.x = mouseX - menuWidth;
        } else {
          this.contextMenu.x = mouseX;
        }

        if (mouseY + menuHeight > viewportHeight) {
          this.contextMenu.y = mouseY - menuHeight;
        } else {
          this.contextMenu.y = mouseY;
        }
      });
      // console.log(this.contextMenu);
    },
    closeContextMenu() {
      this.selectedStamp = null;
      this.externalstampsCount = 0;
      this.selectedEmployee = null;
      this.contextMenu.show = false;
    },
    handleKeydown(event) {
      if (event.key === "Escape" && this.contextMenu.show) {
        this.closeContextMenu();
      }
    },
    hideTooltip() {
      $('.tooltip').hide();
    },
    openExternalStampsModal() {
      this.selectedEmployeeDetails = this.selectedEmployee;
      this.selectedEmployeeStamps = this.selectedEmployee.stamps;
      // console.log('yep ');
      // console.log(this.selectedEmployeeStamps);
      this.selectedEmployeeExternalStamps = this.selectedEmployee.externalstamps;
      console.log(this.selectedEmployeeExternalStamps);
      $("#externalstampsModal").modal("show");
    },
    closeExternalStampsModal() {
      $("#externalstampsModal").modal("hide");
      this.selectedEmployeeDetails = null;
      this.selectedEmployeeStamps = [];
      this.selectedEmployeeExternalStamps = [];
    },
    toggleExternalStamps(employeeId) {
      this.hideTooltip();
      this.showExternalStamps[employeeId] = !this.showExternalStamps[employeeId];
    },
  },
};
</script>

<style scoped>
.active {
  background: green;
}

.context-menu {
  position: fixed;
  background: white;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 200;
  min-width: 200px;
  padding: 4px 0;
}

.context-menu-item {
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #333;
  transition: background-color 0.2s ease;
}

.context-menu-item:hover {
  background-color: #f5f5f5;
}

.context-menu-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 199;
  background: transparent;
}
</style>
